import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, ErrorComponent } from '@tanstack/react-router'

import LoadProgress from '@/components/LoadProgress'

import { membershipDynamicFieldsQueryOptions } from '@/api/mms/mmsDynamicFieldsQueryOptions'
import { NoPermissionError } from '@/api/NoPermissionError'

import { DynamicFieldDataType } from '@/api/dynamicField'
import { MembershipDynamicFieldType } from '@/api/mms/mmsDynamicFields'
import DynamicFieldForm from '@/components/dyn/DynamicFieldForm'
import { NoPermissionErrorComponent } from '@/components/NoPermissionErrorComponent'
import BorderedSection from '@/ui/BorderedSection'
import { Grid } from '@mui/material'

export const Route = createFileRoute(
    '/_auth/member_/$memberUuid/dynamicFieldsGrid'
)({
    component: MemberDynamicFieldsGridComponent,
    errorComponent: ({ error }) => {
        if (error instanceof NoPermissionError) {
            return (
                <NoPermissionErrorComponent error={error}></NoPermissionErrorComponent>
            )
        }
        return <ErrorComponent error={error}></ErrorComponent>
    },
})

function MemberDynamicFieldsGridComponent() {
    const params = Route.useParams()

    const membershipDynamicFieldsQuery = useSuspenseQuery(
        membershipDynamicFieldsQueryOptions(params.memberUuid),
    )
    const membershipDynamicFields = membershipDynamicFieldsQuery.data

    if (membershipDynamicFieldsQuery.isLoading || membershipDynamicFieldsQuery.isFetching) {
        return <LoadProgress />
    }

    const renderDynamicFields = (dynamicFields: MembershipDynamicFieldType[], organizationLevel: string) => {
        const filteredDynamicFields = dynamicFields.filter(
            (df) => df.dynamicField.organization.organizationLevel === organizationLevel,
        )
        if (filteredDynamicFields.length > 0) {
            const typeOrder = Object.values(DynamicFieldDataType);
            const sortedDynamicFields = filteredDynamicFields.sort((a, b) => {
                const aSort = '' + typeOrder.indexOf(a.dynamicField.datatype) + '-' + a.dynamicField.name
                const bSort = '' + typeOrder.indexOf(b.dynamicField.datatype) + '-' + b.dynamicField.name
                return aSort.localeCompare(bSort)
            })
            return (
                <div key={organizationLevel}>
                    <BorderedSection key={'Typography_' + filteredDynamicFields[0].dynamicField.organization.name} title={filteredDynamicFields[0].dynamicField.organization.name}>

                        {sortedDynamicFields.map((membershipDynamicField) => (
                            <Grid container spacing={2} key={'Grid_' + membershipDynamicField.dynamicField.uuid}>
                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 4
                                    }}
                                    key={membershipDynamicField.dynamicField.uuid}>
                                    <DynamicFieldForm dynamicField={membershipDynamicField} memberUuid={params.memberUuid} key={membershipDynamicField.dynamicField.uuid} />
                                </Grid>
                            </Grid>
                        ))}
                    </BorderedSection>
                </div>)
        } else {
            return <div key={organizationLevel}></div>
        }

    }

    return (<>
        {renderDynamicFields(membershipDynamicFields, 'FEDERATION')}
        {renderDynamicFields(membershipDynamicFields, 'DIVISION')}
        {renderDynamicFields(membershipDynamicFields, 'KOLONNE')}
        {renderDynamicFields(membershipDynamicFields, 'TROOP')}



    </>);
}
